module.exports = __webpack_public_path__ + "img/empty-joined-member.f8d17765.svg";